import React, { Fragment, useRef } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import "./header.css";

import "./css/bootstrap.min.css";
import "./css/style.css";

//main-container-page1
const navLinks = [
  {
    display: "Теория",
    url: "/teories",
  },
  {
    display: "Есеп",
    url: "/problems",
  },
  {
    display: "Видео сабақ",
    url: "/videos",
  },
  {
    display: "Тест тапсырмалары",
    url: "/exercises",
  },
  {
    display: "Бағдарлама",
    url: "/programming",
  },
];

const Header = () => {
  const menuRef = useRef();

  const menuToggle = () => menuRef.current.classList.toggle("active__menu");

  return (
    <Fragment>
      <header className="header">
        <Container>
          <div className="container-fluid py-2 border-bottom d-none d-lg-block">
            <div class="container">
              <div class="row">
                <div class="col-md-6 text-center text-lg-start mb-2 mb-lg-0">
                  <div class="d-inline-flex align-items-center">
                    {/* <a class="text-decoration-none text-body pe-3" href=""><i class="bi bi-telephone me-2"></i>+7 776 522 0963</a>
                  <span class="text-body">|</span>
                  <a class="text-decoration-none text-body px-3" href=""><i class="bi bi-envelope me-2"></i>info@example.com</a> */}
                  </div>
                </div>
                <div class="col-md-6 text-center text-lg-end">
                  <div class="d-inline-flex align-items-center">
                    <Link class="text-body ps-2" to="">
                      <i class="ri-linkedin-box-fill"></i>
                    </Link>
                    <Link class="text-body ps-2" to="">
                      <i class="ri-github-fill"></i>
                    </Link>
                    <Link class="text-body ps-2" to="">
                      <i class="ri-instagram-fill"></i>
                    </Link>
                    <a class="text-body ps-2" href="https://begaiymq.github.io/SingIn-SingUp/">
                      <i class="ri-account-circle-fill"></i>
                    </a>
                    <a class="text-body ps-2" href="https://begaiymq.github.io/SingIn-SingUp/">
                      <i class="ri-logout-box-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid sticky-top bg-white shadow-sm">
            <div className="container">
              <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0">
                <Link to="/" className="navbar-brand" style={
                  {
                    fontSize: '50px',
                    color: '#00cbe1',
                  }
                }>
                  <h1 className="m-0 text-uppercase text-primary" style={
                    {
                      color: '#00cbe1',
                    }
                  }><i class="fa fa-clinic-medical me-2"></i>
                    <img src="./logo-pg.png" alt="" width='80px' />
                    &nbsp;&nbsp;&nbsp;
                    PHYSIPY
                  </h1>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                  <div className="navbar-nav ms-auto py-0">
                    <Link to="/teories" className="nav-item nav-link active">Теория</Link>
                    <div className="nav-item">
                      <button className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Есеп</button>
                      <div className="dropdown-menu m-0">
                        <Link to="/problems" className="dropdown-item">ЭЛЕКТРОСТАТИКА</Link>
                        <Link to="/constant-electric-current-ohm's-laws" className="dropdown-item">ТҰРАҚТЫ ЭЛЕКТР ТОГЫ. ОМ ЗАҢДАРЫ</Link>
                        <Link to="/magnetostatics-problems" className="dropdown-item">МАГНИТОСТАТИКА</Link>
                        <Link to="/electromagnetic-induction-phenomenon" className="dropdown-item">ЭЛЕКТРОМАГНИТТІК ИНДУКЦИЯ ҚҰБЫЛЫСЫ</Link>
                      </div>
                    </div>
                    <Link to="/videos" className="nav-item nav-link">Видео сабақ</Link>
                    <a href="https://begaiymq.github.io/QuizLet-Begaiym/" className="nav-item nav-link">Тест тапсырмалары</a>
                    <a href="https://www.jetbrains.com/ru-ru/pycharm/" className="nav-item nav-link">Бағдарлама</a>


                    <a className="nav-item nav-link" href="https://begaiymq.github.io/SingIn-SingUp">Байланыс</a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </Container>
      </header>
      <br /><br /><br /><br />
    </Fragment>
  );
};

export default Header;
